var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCarPrimary1414 = function SvgCarPrimary1414(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#669AFF",
    d: "M10.748 3.214a.81.81 0 0 0-.769-.547H4.021a.815.815 0 0 0-.77.547L2.126 6.458v4.063a.811.811 0 1 0 1.625 0v-.271h6.5v.27c0 .445.363.813.813.813a.815.815 0 0 0 .812-.812V6.458zm-6.185 5.41a.811.811 0 1 1 0-1.624.811.811 0 1 1 0 1.625m4.875 0a.811.811 0 1 1 0-1.624.811.811 0 1 1 0 1.625m-5.79-3.25L4.21 3.75h5.574l.563 1.625z"
  })));
};
export default SvgCarPrimary1414;